import React from "react";
import CoreH from "./CoreH";

export default function CoreH6(props) {
  return (
    <CoreH {...props} variant="h6" component="h6">
      {props?.children}
    </CoreH>
  );
}
